export const WIVES = [
  { name: 'SARAH', tag: 'S', color: '#ff5b1f' },
  { name: 'LINH', tag: 'L', color: '#c9ff3a' },
  { name: 'TINA', tag: 'T', color: '#de0086' },
  { name: 'JESS', tag: 'J', color: '#f4c64a' },
  { name: 'MEI', tag: 'M', color: '#3aa8ff' }
];

export const WAG_MSGS = [
  { from: 'SARAH', text: 'Tom said "one more game" two hours ago' },
  { from: 'LINH', text: 'Greg called it a "roster" again 💀' },
  { from: 'TINA', text: 'they have sponsors now??' },
  { from: 'JESS', text: 'Marcus claims mid lane is "cardiovascular"' },
  { from: 'MEI', text: 'Ben muted me on the baby monitor' },
  { from: 'SARAH', text: "Tom said GG and didn't come upstairs" },
  { from: 'LINH', text: 'they have a LOGO. like a real one.' },
  { from: 'TINA', text: 'Greg just yelled "PUSH MID" at the toddler' },
  { from: 'JESS', text: 'fine. let them have this. who am I to stop joy.' },
  { from: 'MEI', text: 'the diaper is a "strategy" now apparently' },
  { from: 'SARAH', text: 'scheduling an intervention. snacks provided.' },
  { from: 'LINH', text: 'Greg bought matching team jerseys. plural.' },
  { from: 'TINA', text: 'is mythic glory a real thing or no' },
  { from: 'JESS', text: 'I made him a sandwich. peace offering.' },
  { from: 'MEI', text: 'wait the team is actually winning??' },
  { from: 'SARAH', text: 'ok but the merch is kind of cute ngl' },
  { from: 'LINH', text: "is it pathetic if I'm a little proud" },
  { from: 'TINA', text: 'Greg is currently 5-0 and bringing me wine.' },
  { from: 'JESS', text: 'approved. for tonight only. one match.' },
  { from: 'MEI', text: "vetoing tournament saturday. it's our anniversary." },
  { from: 'SARAH', text: 'they\'re calling themselves "a collective" now' },
  { from: 'LINH', text: "the captain is the one who can't find his shoes" }
];

export const REASONS = [
  'DIAPER',
  'SNACK REQUEST',
  'WIFE INBOUND',
  'BABY MONITOR PING',
  'TEETHING EVENT',
  'BEDTIME STORY',
  'SCHOOL PICKUP'
];
